module.exports = __webpack_public_path__ + "img/step9(2).02a944ee.png";